module.exports = __webpack_public_path__ + "static/media/yellow_heart.d03e26cf.svg";